<script setup>
definePageMeta({
  name: "hjem",
  layout: "default",
})

useHead({
  bodyAttrs: {
    class: "bg-[--theme-lightest]",
  },
})
</script>

<template>
  <div
    class="flex flex-col items-center justify-center w-full mb-14 gap-14"
  >
    <UPlatformDescription />
    <UProductList />
  </div>
</template>
